class CollectionPaginationLabel extends window.BAO.CustomElement({
  SuperClass: HTMLParagraphElement,
}) {
  constructor () {
    super()
    this._mutationObserver = null
    this.context = this.getAttribute('data-context') || 'shopify'

    if (this.context === 'nosto') {
      this.eventBus = window.theme.results.eventBus
      this.setupEventListeners()
    }
  }

  connectedCallback () {
    const externalLabel = document.querySelectorAll(
      '[data-collection-pagination-label-external-el="label"]',
    )

    if (externalLabel[1]) {
      this.textContent = externalLabel[1].textContent
    }
  }

  setupEventListeners () {
    this.eventBus.subscribe(
      window.theme.results.events.STATE.PAGINATION_UPDATED,
      pagination => {
        this.textContent = `${pagination.total} items`
      },
    )
  }
}

customElements.define(
  'collection-pagination-label',
  CollectionPaginationLabel,
  {
    extends: 'p',
  },
)
